import { render, staticRenderFns } from "./KiberCourse.vue?vue&type=template&id=7f83b610&scoped=true&"
import script from "./KiberCourse.vue?vue&type=script&lang=js&"
export * from "./KiberCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f83b610",
  null
  
)

export default component.exports